import React, { useState, useEffect } from 'react';
import { FaUsers, FaUserCheck, FaRegUser } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';
import api from '../../api/Api';
import DownlineModal from './DownlineModal';
const MyTeam = () => {
  const { isDarkMode } = useTheme();

  const [activeTab, setActiveTab] = useState('Direct');
  const [teamData, setTeamData] = useState([]);
  const [levelCounts, setLevelCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false)
  const [levelId, setLevelId] = useState('')
  // ── COLORS (aapke exact variables) ──────────────────────────────────────
  const G = '#d4af37';
  const G2 = '#f0c842';
  const card = isDarkMode ? '#171717' : '#ffffff';
  const border = isDarkMode ? 'rgba(255,255,255,.06)' : 'rgba(0,0,0,.06)';
  const text = isDarkMode ? '#ffffff' : '#111111';
  const muted = isDarkMode ? '#9ca3af' : '#6b7280';
  const headBg = isDarkMode ? '#1d1d1d' : '#faf8f3';
  const tabBg = isDarkMode ? '#111' : '#f5f5f5';

  // ── FETCH ────────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchTeam = async () => {
      setLoading(true);
      try {
        const res = await api.get('my-team');
        const { allTeamData = [], levelCounts = {} } = res.data?.data || {};
        setTeamData(allTeamData);
        setLevelCounts(levelCounts);
      } catch (err) {
        console.error('my-team fetch error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchTeam();
  }, []);

  // ── FILTERED DATA per tab ────────────────────────────────────────────────
  const directData = teamData.filter(m => m.level === 1);
  const activeData = teamData.filter(m => m.user?.user_status === 'active');
  const allData = teamData;

  const tabMap = {
    Direct: allData,
    Team: allData,
    Active: activeData,
  };

  const filtered = tabMap[activeTab] || [];

  // ── STATS ────────────────────────────────────────────────────────────────
  const stats = [
    { title: 'Direct', count: levelCounts[1] || directData.length, icon: <FaRegUser />, color: G },
    { title: 'Active', count: activeData.length, icon: <FaUserCheck />, color: '#10b981' },
    { title: 'Team', count: allData.length, icon: <FaUsers />, color: '#3b82f6' },
  ];

  // ── HELPERS ──────────────────────────────────────────────────────────────
  const fmtDate = (str) => {
    if (!str) return '—';
    const d = new Date(str);
    const now = new Date();
    const diff = Math.floor((now - d) / 86400000);
    if (diff === 0) return 'Today';
    if (diff === 1) return 'Yesterday';
    if (diff < 7) return `${diff} Days Ago`;
    if (diff < 30) return `${Math.floor(diff / 7)} Week${Math.floor(diff / 7) > 1 ? 's' : ''} Ago`;
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const getMemberStatus = (u) => {
    if (u?.profile_status === 'approved') return { label: 'Verified', bg: 'rgba(16,185,129,.12)', color: '#10b981' };
    if (u?.user_status === 'active') return { label: 'Active', bg: 'rgba(59,130,246,.12)', color: '#3b82f6' };
    return { label: 'Pending', bg: 'rgba(245,158,11,.12)', color: '#f59e0b' };
  };

  const handleView = (level) => {
    setLevelId(level)
    setModalOpen(true)
  }

  // ── RENDER ───────────────────────────────────────────────────────────────
  return (
    <div style={{ width: '100%' }}>

      {/* STATS */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit,minmax(120px,1fr))',
        gap: 12, marginBottom: 18,
      }}>
        {stats.map((item, i) => (
          <div key={i} style={{
            background: card, border: `1px solid ${border}`,
            borderRadius: 18, padding: '14px 16px',
            display: 'flex', alignItems: 'center', gap: 12,
          }}>
            <div style={{
              width: 38, height: 38, borderRadius: 12,
              background: `${item.color}15`, color: item.color,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 15, flexShrink: 0,
            }}>
              {item.icon}
            </div>
            <div>
              <div style={{ fontSize: 11, color: muted, fontWeight: 600, marginBottom: 3 }}>{item.title}</div>
              <div style={{ fontSize: 24, fontWeight: 800, color: text, lineHeight: 1 }}>
                {loading ? '—' : item.count}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* MAIN CARD */}
      <div style={{ background: card, borderRadius: 22, border: `1px solid ${border}`, overflow: 'hidden' }}>

        {/* HEADER */}
        <div style={{
          padding: '18px 20px', borderBottom: `1px solid ${border}`,
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', flexWrap: 'wrap', gap: 14,
        }}>
          <div>
            <div style={{ color: G, fontSize: 10, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 4 }}>
              Referral Network
            </div>
            <div style={{ color: text, fontSize: 22, fontWeight: 800 }}>My Team</div>
          </div>

          {/* TABS */}
          <div style={{ display: 'flex', gap: 8, background: tabBg, padding: 5, borderRadius: 14 }}>
            {['Direct', 'Team', 'Active'].map(tab => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  padding: '9px 16px', borderRadius: 10, border: 'none',
                  background: activeTab === tab ? `linear-gradient(135deg,${G},${G2})` : 'transparent',
                  color: activeTab === tab ? '#000' : muted,
                  fontWeight: 700, fontSize: 12, cursor: 'pointer',
                  transition: 'all .15s',
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* TABLE */}
        {activeTab === "Direct" && (
          <div style={{ overflowX: 'auto' }}>
            {loading ? (
              <div style={{ padding: 48, textAlign: 'center', color: muted, fontSize: 14 }}>
                Loading…
              </div>
            ) : filtered.length === 0 ? (
              <div style={{ padding: 48, textAlign: 'center', color: muted, fontSize: 14 }}>
                No members found.
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ background: headBg }}>
                  <tr>
                    {['Name', 'Mobile', 'Status', 'Joined'].map(h => (
                      <th key={h} style={{
                        padding: '16px 18px', textAlign: 'left',
                        color: muted, fontSize: 11, fontWeight: 700,
                        letterSpacing: 1, textTransform: 'uppercase',
                        borderBottom: `1px solid ${border}`, whiteSpace: 'nowrap',
                      }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((member, index) => {
                    const u = member.user || {};
                    const st = getMemberStatus(u);
                    return (
                      <tr key={member.id} style={{
                        background: index % 2 === 0
                          ? 'transparent'
                          : isDarkMode ? '#141414' : '#fcfcfc',
                      }}>

                        {/* NAME */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}` }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <img
                              src={u.profile_image || `https://ui-avatars.com/api/?name=${encodeURIComponent(u.name || 'U')}&background=d4af37&color=000000&size=38`}
                              alt={u.name}
                              style={{ width: 38, height: 38, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                              onError={e => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(u.name || 'U')}&background=d4af37&color=000000&size=38`; }}
                            />
                            <div>
                              <div style={{ color: text, fontWeight: 700, fontSize: 14, whiteSpace: 'nowrap' }}>
                                {u.name || member.name}
                              </div>
                              <div style={{ color: muted, fontSize: 11, marginTop: 1 }}>
                                ID: {u.my_code || '—'}
                              </div>
                            </div>
                          </div>
                        </td>

                        {/* MOBILE */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}`, color: muted, fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap' }}>
                          {u.mobile || '—'}
                        </td>

                        {/* STATUS */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}` }}>
                          <div style={{
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            padding: '6px 12px', borderRadius: 30,
                            background: st.bg, color: st.color,
                            fontSize: 11, fontWeight: 700,
                          }}>
                            {st.label}
                          </div>
                        </td>

                        {/* JOINED */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}`, color: muted, fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap' }}>
                          {fmtDate(member.join_date)}
                        </td>
                        {/* JOINED */}

                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>)}

        {activeTab === "Team" && (
          <div style={{ overflowX: 'auto' }}>
            {loading ? (
              <div style={{ padding: 48, textAlign: 'center', color: muted, fontSize: 14 }}>
                Loading…
              </div>
            ) : filtered.length === 0 ? (
              <div style={{ padding: 48, textAlign: 'center', color: muted, fontSize: 14 }}>
                No members found.
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ background: headBg }}>
                  <tr>
                    {['Name', 'Mobile', 'Status', 'Joined', 'action'].map(h => (
                      <th key={h} style={{
                        padding: '16px 18px', textAlign: 'left',
                        color: muted, fontSize: 11, fontWeight: 700,
                        letterSpacing: 1, textTransform: 'uppercase',
                        borderBottom: `1px solid ${border}`, whiteSpace: 'nowrap',
                      }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((member, index) => {
                    const u = member.user || {};
                    const st = getMemberStatus(u);
                    return (
                      <tr key={member.id} style={{
                        background: index % 2 === 0
                          ? 'transparent'
                          : isDarkMode ? '#141414' : '#fcfcfc',
                      }}>

                        {/* NAME */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}` }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <img
                              src={u.profile_image || `https://ui-avatars.com/api/?name=${encodeURIComponent(u.name || 'U')}&background=d4af37&color=000000&size=38`}
                              alt={u.name}
                              style={{ width: 38, height: 38, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                              onError={e => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(u.name || 'U')}&background=d4af37&color=000000&size=38`; }}
                            />
                            <div>
                              <div style={{ color: text, fontWeight: 700, fontSize: 14, whiteSpace: 'nowrap' }}>
                                {u.name || member.name}
                              </div>
                              <div style={{ color: muted, fontSize: 11, marginTop: 1 }}>
                                ID: {u.user_id || '—'}
                              </div>
                            </div>
                          </div>
                        </td>

                        {/* MOBILE */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}`, color: muted, fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap' }}>
                          {u.mobile || '—'}
                        </td>

                        {/* STATUS */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}` }}>
                          <div style={{
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            padding: '6px 12px', borderRadius: 30,
                            background: st.bg, color: st.color,
                            fontSize: 11, fontWeight: 700,
                          }}>
                            {st.label}
                          </div>
                        </td>

                        {/* JOINED */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}`, color: muted, fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap' }}>
                          {fmtDate(member.join_date)}
                        </td>
                        {/* JOINED */}
                        <td style={{ padding: '16px 18px', cursor: "pointer", fontSize: "14px", fontWeight: 500, whiteSpace: 'nowrap' }}>
                          <div onClick={() => handleView(member.level)}> view  </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        )}


        {activeTab === "Active" && (
          <div style={{ overflowX: 'auto' }}>
            {loading ? (
              <div style={{ padding: 48, textAlign: 'center', color: muted, fontSize: 14 }}>
                Loading…
              </div>
            ) : filtered.length === 0 ? (
              <div style={{ padding: 48, textAlign: 'center', color: muted, fontSize: 14 }}>
                No members found.
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ background: headBg }}>
                  <tr>
                    {['Name', 'Mobile', 'Status', 'Joined'].map(h => (
                      <th key={h} style={{
                        padding: '16px 18px', textAlign: 'left',
                        color: muted, fontSize: 11, fontWeight: 700,
                        letterSpacing: 1, textTransform: 'uppercase',
                        borderBottom: `1px solid ${border}`, whiteSpace: 'nowrap',
                      }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((member, index) => {
                    const u = member.user || {};
                    const st = getMemberStatus(u);
                    return (
                      <tr key={member.id} style={{
                        background: index % 2 === 0
                          ? 'transparent'
                          : isDarkMode ? '#141414' : '#fcfcfc',
                      }}>

                        {/* NAME */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}` }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <img
                              src={u.profile_image || `https://ui-avatars.com/api/?name=${encodeURIComponent(u.name || 'U')}&background=d4af37&color=000000&size=38`}
                              alt={u.name}
                              style={{ width: 38, height: 38, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                              onError={e => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(u.name || 'U')}&background=d4af37&color=000000&size=38`; }}
                            />
                            <div>
                              <div style={{ color: text, fontWeight: 700, fontSize: 14, whiteSpace: 'nowrap' }}>
                                {u.name || member.name}
                              </div>
                              <div style={{ color: muted, fontSize: 11, marginTop: 1 }}>
                                ID: {u.user_id || '—'}
                              </div>
                            </div>
                          </div>
                        </td>

                        {/* MOBILE */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}`, color: muted, fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap' }}>
                          {u.mobile || '—'}
                        </td>

                        {/* STATUS */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}` }}>
                          <div style={{
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            padding: '6px 12px', borderRadius: 30,
                            background: st.bg, color: st.color,
                            fontSize: 11, fontWeight: 700,
                          }}>
                            {st.label}
                          </div>
                        </td>

                        {/* JOINED */}
                        <td style={{ padding: '16px 18px', borderBottom: `1px solid ${border}`, color: muted, fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap' }}>
                          {fmtDate(member.join_date)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        )}
        <DownlineModal
          visible={modalOpen}
          onClose={() => setModalOpen(false)}
          levelId={levelId}
        />

      </div>
    </div>
  );
};

export default MyTeam;